interface CacheItem<T> {
  data: T;
  timestamp: number;
  expiry: number;
}

function getCachedData<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const cachedItem: CacheItem<T> = JSON.parse(item);
    if (Date.now() > cachedItem.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return cachedItem.data;
  } catch (error) {
    console.error('Error reading from cache:', error);
    return null;
  }
}

function setCachedData<T>(key: string, data: T, duration: number): void {
  try {
    const item: CacheItem<T> = {
      data,
      timestamp: Date.now(),
      expiry: Date.now() + duration
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error('Error writing to cache:', error);
  }
}

export { getCachedData, setCachedData };